<template>
  <div class="list">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="search_form">
        <el-form-item label="乐刷商户号">
            <el-select
              class="selectWidth"
              v-model="search_form.FMerchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              remote
              :remote-method="handleMerchantInfoRemote"
              :loading="selectLoading">
              <el-option
                v-for="item in subMerchantNamesList"
                :key="item.fmerchantId"
                :label="item.fmerchantId"
                :value="item.fmerchantId">
                <span class="value">{{ item.fmerchantId }}</span>
                <span class="name">{{ item.fmerchantName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="开票类型">
          <el-select
            class="selectWidth"
            v-model="search_form.FInvoiceType"
            clearable>
            <el-option v-for="item in invoiceTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            class="selectWidth"
            v-model="search_form.FState"
            clearable>
            <el-option value="" label="全部" disabled hidden></el-option>
            <el-option v-for="item in statusList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票方式">
          <el-select
            class="selectWidth"
            v-model="search_form.FIssueInvoiceType"
            clearable>
            <el-option value="" label="全部" disabled hidden></el-option>
            <el-option v-for="item in invoiceMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="直属代理商">
            <el-select
              class="selectWidth"
              v-model="search_form.FAgentId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleAgentInfoFilter">
              <el-option
                v-for="item in subAgentInfoList"
                :key="item.fAgentId + item.fcreateTime"
                :label="item.fAgentId"
                :value="item.fAgentId"
                style="width: 200px">
                <span class="value">{{ item.fAgentId }}</span>
                <span class="name">{{ item.fTitle }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="最近修改时间">
          <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="费用类型">
          <el-select
            class="selectWidth"
            v-model="search_form.FFeeType"
            clearable>
            <el-option value="" label="全部" disabled hidden></el-option>
            <el-option v-for="item in feeTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <auth-button
          opt="search"
          :plain="true"
          @click.native="search"
          :loading="loading"
          icon="el-icon-search"
          label="查询"
          style="margin-bottom: 15px;"></auth-button>
        <auth-button opt="add" @click.native="applyInvoice(sameSubject = false)" label="新增配置" style="margin-bottom: 20px"></auth-button>
        <auth-button opt="add_sub" @click.native="applyInvoice(sameSubject = true)" label="新增同主体配置" style="margin-bottom: 20px"></auth-button>
      </el-form>
      <div class="tips">温馨提示：配置自动开票后无须每月手动申请开票，系统会根据您设定的开票方式及周期自动申请开票</div>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        align="center"
        v-loading="loading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fMerchantId"
          label="乐刷商户号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="直属代理商编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMultiFlag"
          label="商户合并"
          align="center">
          <template slot-scope="scope">
            {{scope.row.fMultiFlag === 0 ? '单商户' : '同主体多商户'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="fInvoiceTypeDesc"
          label="开票类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fIssueInvoiceTypeDesc"
          label="开票方式"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fFeeTypeDesc"
          label="费用类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fStateDesc"
          label="状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fUpdateTime"
          label="最近修改时间"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="change_status"
              type="text"
              :label="scope.row.fState === 0 ? '停用' : '启用'"
              @click.native="changeState(scope.row)"></auth-button>
            <auth-button
              opt="edit"
              type="text"
              label="编辑"
              @click.native="editInvoice(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
    <el-dialog :visible.sync="applyDialogVisible" width="850px" title="自动开票配置" @close="closeViewDialog" :close-on-click-modal="false">
      <apply-form
        @submit="submit"
        :submit-loading="submitLoading"
        :visible="applyDialogVisible"
        :ids="[selectedRow.fId]"
        :showInvoiceRemark="showInvoiceRemark"
        :selectedMerchantId="selectedMerchantId"
        :selectedRow="selectedRow"
        :auto="true"
        :isSameSubject="isSameSubject"
      ></apply-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import applyForm from './applyForm'
import { listAutoInvoice, applyAutoInvoice, updateAutoInvoice, updateAutoInvoiceState, listAgentMerchant } from '@/api/settle'
import { subAgentInfo } from '@/api/merchant'
export default {
  name: 'AutoApplyInvoice',
  components: {
    dateRangePicker,
    pagination,
    applyForm
  },
  data () {
    return {
      loading: false,
      search_form: {
        FMerchantId: '',
        FStartTime: '', // 开始时间
        FEndTime: '', // 结束时间
        FInvoiceType: '', // 商户编号
        FState: '', // 发票设置状态
        FIssueInvoiceType: '', // 开票类型
        FAgentId: '', // 代理商编号
        FFeeType: '' // 代理商编号
      },
      creatTime: [], // 创建时间
      list: [],
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      applyDialogVisible: false, // 发票弹窗是否显示
      selectedIds: [], // 选中的费用记录id
      selectedAmount: 0, // 选中的费用总数
      selectedDesc: [], // 选中的描述
      submitLoading: false,
      isAgent: true, // 是否是代理商
      sameMerchant: true, // 是否是同一个商户
      selectedRow: {}, // 选中的单个发票
      single: false, // 是否是单独发票
      showInvoiceRemark: false,
      selectedMerchantId: '', // 选中数据商户id
      invoiceTypeList: [
        { text: '普通增值税发票', value: 0 },
        { text: '专用增值税发票', value: 1 }
      ], // 开票类型映射
      invoiceMethodList: [
        { text: '合并开票', value: 0 },
        { text: '逐月开票', value: 1 }
      ], // 开票方式映射
      statusList: [
        { text: '启用中', value: 0 },
        { text: '停用', value: 1 }
      ], // 开票方式映射
      feeTypeList: [
        { text: '交易手续费', value: 0 },
        { text: '花呗贴息费', value: 2 },
        { text: '其它', value: 1 }
      ], // 费用类型映射 0.交易手续费 1.其它 2 花呗贴息费
      type: 'apply', // apply update
      selectLoading: false,
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      isSameSubject: false // 是否是同主体开票
    }
  },
  mounted () {
    this.getList()
    this.getSubAgentInfo()
  },
  methods: {
    /**
         * @description 日期组件选中事件
         * @param  {String} value 当前结果
         */
    dateChange (value) {
      this.creatTime = value
    },
    /**
         * @description 点击查询
         */
    search () {
      this.paginations.pageNo = 1
      this.getList()
    },
    /**
         * @description 列表请求
         */
    getList () {
      this.search_form.FStartTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.search_form.FEndTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      const that = this
      that.loading = true
      const data = qs.stringify(Object.assign({}, this.search_form, this.paginations))
      listAutoInvoice(data).then(response => {
        that.loading = false
        if (response.error_code === '0') {
          that.paginations.count = response.data.totalCount
          that.list = response.data.list
          that.showInvoiceRemark = response.data.agentIds && response.data.agentIds.includes(that.$store.getters.userId)
        } else {
          that.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 清除对象中无值属性
         */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
         * @description 改变当前页事件
         * @param  {Object} value 当前结果
         */
    onChangeCurrentPage (value) {
      this.paginations.pageNo = value
      this.getList()
    },
    applyInvoice (sameSubject) {
      this.isSameSubject = sameSubject
      this.selectedRow = {}
      this.selectedMerchantId = ''
      this.applyDialogVisible = true
      this.type = 'apply'
    },
    /**
         * @description 申请发票
         * @param  {Object} value 当前行
         */
    editInvoice (row) {
      this.selectedRow = row
      this.selectedMerchantId = row.fMerchantId
      this.applyDialogVisible = true
      this.isSameSubject = !!row.fMultiFlag
      this.type = 'update'
    },
    /**
         * @description 关闭弹窗
         */
    closeViewDialog () {
      this.applyDialogVisible = false
      this.readOnly = false
    },
    /**
         * @description 表格选择修改时间
         * @param  {Object} selection 选中对象
         */
    selectRows (selection) {
      const that = this
      that.selectedIds = []
      that.selectedDesc = []
      that.selectedAmount = 0
      that.sameMerchant = true
      if (selection.length > 0) {
        const merchantId = selection[0].fMerchantId
        that.selectedMerchantId = merchantId
        selection.map(function (item) {
          if (item.fMerchantId !== merchantId) that.sameMerchant = false
          that.selectedIds.push(item.fId)
          that.selectedDesc.push(item.fFeeDetail)
          that.selectedAmount += parseFloat(item.fAmount * 100) / 100
        })
      }
    },

    /**
         * @description 表单校验
         */
    submit (form) {
      let param = form
      delete param.fUpdateTime
      delete param.fCreateTime
      this.submitLoading = true
      param = qs.stringify(this.dismissBlank(param))
      if (this.type === 'apply') {
        applyAutoInvoice(param).then(data => {
          this.submitLoading = false
          if (data.error_code === '0') {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            this.applyDialogVisible = false
            this.getList()
            this.single = false
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.submitLoading = false
        })
      } else {
        updateAutoInvoice(param).then(data => {
          this.submitLoading = false
          if (data.error_code === '0') {
            this.$message({
              message: data.error_msg,
              type: 'success'
            })
            this.applyDialogVisible = false
            this.getList()
            this.single = false
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.submitLoading = false
        })
      }
    },
    /**
         * @description 删除对象中字符串的空格
         * @param  {number} params 目标对象
         */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
          const element = params[key]
          if (typeof element === 'string') {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      return params
    },
    /**
         * @description 批量申请发票
         */
    batchApply () {
      if (this.selectedIds.length === 0) {
        this.$message({
          message: '请先选择同一个商户的费用记录',
          type: 'warning'
        })
        return
      }
      if (!this.sameMerchant) {
        this.$message({
          message: '请先筛选同一个商户，方可申请批量开票',
          type: 'warning'
        })
      } else {
        this.applyDialogVisible = true
        this.single = false
      }
    },
    changeState (row) {
      const that = this
      this.$confirm(`是否${row.fState === 0 ? '停用' : '启用'}该配置信息`, '提示', {}).then(() => {
        const params = qs.stringify({
          fId: row.fId,
          fState: Number(!row.fState)
        })
        updateAutoInvoiceState(params).then(res => {
          if (parseInt(res.error_code) === 0) {
            that.$message({
              type: 'success',
              showClose: true,
              message: '修改状态成功'
            })
            that.getList()
          } else {
            that.$message({
              type: 'error',
              showClose: true,
              message: res.error_msg
            })
          }
        })
      })
    },
    /**
     * 商户信息自定义筛选方法
     */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.listAgentMerchant(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    /**
             * 获取代理商下所有商户列表
             */
    listAgentMerchant (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
             * 直属代理商自定义筛选方法
             */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.subAgentInfoList = this.subAgentInfoList_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subAgentInfoList = this.subAgentInfoList_back
      }
    },
    /**
             * @description 获取下级代理商下拉列表
             */
    getSubAgentInfo () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        subAgentInfo('pageSize=65535').then(response => {
          if (response.error_code === '0') {
            const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
            const agentList = [{
              fAgentId: userInfo.fAgentId,
              fTitle: userInfo.fTitle
            }]
            this.subAgentInfoList = agentList.concat(response.list)
            this.subAgentInfoList_back = [...this.subAgentInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch((e) => {
          reject(e)
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>
  .list{
    padding-left: 16px;
  }
  .tips {
    font-size: 12px;
    color: #606266;
    margin-bottom: 14px;
  }
  .pagination {
    display: inline-block;
  }
</style>
